import React, { useEffect } from 'react';
import '../components/css/NodeProgressPopup.css';

const NodeProgressPopup = ({ chain, blockHeight, blocksRemaining, syncProgress, nodeCatchingUp, isLoading, isSetupComplete, setupFailed, setupMessage, onClose }) => {
  useEffect(() => {
    const onKeyDown = (event) => { if (event.key === 'Escape') onClose(); };
    window.addEventListener('keydown', onKeyDown);
    return () => window.removeEventListener('keydown', onKeyDown);
  }, [onClose]);

  const hasHeight = blockHeight.node > 0 && blockHeight.chain > 0;
  const synced = hasHeight && (nodeCatchingUp === false || (nodeCatchingUp === null && blocksRemaining <= 2));
  const title = setupFailed ? 'Setup needs attention'
    : isSetupComplete ? 'Validator setup complete'
    : synced ? (isLoading ? 'Node synced · Finishing setup' : 'Node is synced')
    : blockHeight.node > 0 ? `Syncing with ${chain.network}`
    : isLoading ? 'Preparing your node' : 'Waiting for node data';
  const detail = setupFailed ? setupMessage
    : isSetupComplete ? setupMessage
    : !hasHeight ? 'The node height will appear here as soon as the node starts reporting blocks.'
    : synced ? 'Your node has caught up with the network.'
    : `${blocksRemaining?.toLocaleString() || '—'} blocks remain before the node catches up.`;

  return (
    <div className="node-progress-overlay" role="presentation">
      <section className="node-progress-dialog" role="dialog" aria-modal="true" aria-labelledby="node-progress-title" aria-describedby="node-progress-detail">
        <div className="node-progress-topline"><span>{chain.network} · Live node status</span><button type="button" className="node-progress-close" onClick={onClose} aria-label="Close node progress">×</button></div>
        <div className="node-progress-header">
          <span className={`node-progress-indicator ${hasHeight && !synced ? 'pulse' : ''}`} aria-hidden="true" />
          <div><h2 id="node-progress-title">{title}</h2><p id="node-progress-detail">{detail}</p></div>
        </div>
        <div className="node-progress-meter-heading"><span>Blockchain sync</span><strong>{hasHeight ? `${syncProgress}%` : 'Preparing'}</strong></div>
        <div className="node-progress-meter" role={hasHeight ? 'progressbar' : undefined} aria-label="Node blockchain sync" aria-valuenow={hasHeight ? syncProgress : undefined} aria-valuemin={hasHeight ? 0 : undefined} aria-valuemax={hasHeight ? 100 : undefined}>
          <div className={`node-progress-meter-fill ${hasHeight ? '' : 'indeterminate'}`} style={hasHeight ? { width: `${syncProgress}%` } : undefined} />
        </div>
        <div className="node-progress-heights">
          <div><span>Network height</span><strong>{blockHeight.chain ? blockHeight.chain.toLocaleString() : 'Checking…'}</strong></div>
          <div><span>Your node</span><strong>{blockHeight.node ? blockHeight.node.toLocaleString() : 'Starting…'}</strong></div>
          <div><span>Blocks remaining</span><strong>{blocksRemaining === null ? '—' : blocksRemaining.toLocaleString()}</strong></div>
        </div>
        <div className="node-progress-footer">
          <span>{isLoading ? 'Setup is running. You can close this window and reopen it from the page.' : 'Updates every 6 seconds while this page is open.'}</span>
          <button type="button" onClick={onClose}>Close</button>
        </div>
      </section>
    </div>
  );
};

export default NodeProgressPopup;
